import { useTranslation } from 'react-i18n-lite'
import { useSearchParams } from 'react-router-dom'

const useHandleLanguage = () => {
  const { setLanguage } = useTranslation()
  const [searchParams] = useSearchParams()
  const lang = searchParams.get('lang')

  if (lang) {
    setLanguage(lang)
  }
}

export default useHandleLanguage
